/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FieldArray, reduxForm } from 'redux-form';
import { makeStyles } from '@material-ui/core/styles';
import RenderProducts from './RenderProducts';
import { updateItems } from '../../../commandsActions';
import { displayInAppError } from '../../../../../utils/toast/Toast';
import validate from './validate';

const useStyles = makeStyles(theme => ({
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(3)
  },
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(3)
  },
  paper: {
    padding: theme.spacing(2),
    margin: 'auto',
    maxWidth: 500
  }
}));

/* eslint-disable import/no-mutable-exports */
let ProductUpdate = ({ handleSubmit }) => {
  const classes = useStyles();
  return (
    <form className={classes.form} onSubmit={handleSubmit} noValidate>
      <FieldArray name="items" component={RenderProducts} />
    </form>
  );
};

const mapStateToProps = state => ({
  currentCommand: state.commands.currentCommand,
  productBarcode: state.init.productBarcode,
  isStockHandled: state.init.isStockHandled,
  initialValues: {
    items: state.commands.currentCommand.items.map((item, index) => ({
      ...item,
      customsDeclaration:
        state.commands.currentCommand.customsDeclarations[index]
    }))
  }
});

ProductUpdate = reduxForm({
  form: 'productUpdateForm',
  enableReinitialize: true,
  validate,
  onSubmit: (values, dispatch, props) => {
    const newValues = { ...values };
    if (!newValues.items.length) {
      return displayInAppError(
        'Votre commande doit contenir au moins un produit'
      );
    }
    newValues.items = newValues.items.map(item => {
      const newItem = { ...item };
      if (newItem.customsDeclaration) {
        newItem.sellingPriceValue = newItem.customsDeclaration.declaredValue;
        newItem.sellingPriceCurrency = newItem.customsDeclaration.currency;
      }
      return newItem;
    });
    const { id } = props.currentCommand;
    const data = {
      id,
      ...newValues,
      customsDeclarations: newValues.items
        .filter(value => value.customsDeclaration)
        .map((value, index) => ({
          ...value.customsDeclaration,
          quantity: newValues.items[index].quantity
        }))
    };
    return dispatch(updateItems(data));
  }
})(ProductUpdate);

ProductUpdate.propTypes = {
  handleSubmit: PropTypes.func
};

export default withRouter(connect(mapStateToProps)(ProductUpdate));
